import api from '@/api';

const resource = 'merenda/saida-turma';

export default {
  buscarSaidas( identificadorcardapioescola, cdturma ) {
    return api.get( `${resource}`, { params: {identificadorcardapioescola, cdturma} });
  },

  inserirSaidas( identificadorcardapioescola, cdturma, saidas ) {
    return api.post( `${resource}`, { identificadorcardapioescola, cdturma, saidas } );
  },
};
